import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

const apiEndpoint = "api/auersteel/v1/session/resetDefaultCustomers";

export const AuerResetDefaultCustomers = async (): Promise<ServiceResult<void>> => {
    try {
        const result = await post<WarehouseModel, void>(`${apiEndpoint}`);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: "Something Went Wrong",
            };
        }
        throw error;
    }
};